import { render, staticRenderFns } from "./CheckoutTotal.vue?vue&type=template&id=4ced658c"
import script from "./CheckoutTotal.vue?vue&type=script&lang=js"
export * from "./CheckoutTotal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports